import { createSvgIcon } from '@mui/material/utils'

export const SecurityIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 48" fill="currentColor">
    <path
      d="M21.6666 24.8851L17.7816 21.0001L15.6666 23.1151L21.6666 29.1151L33.6666 17.1151L31.5516 15.0001L21.6666 24.8851Z"
      fill="currentColor"
    />
    <path
      d="M24.6666 45.0001L15.4029 40.0608C12.7618 38.6558 10.5532 36.5581 9.01406 33.9929C7.47493 31.4276 6.66343 28.4917 6.66664 25.5001V6.00012C6.66747 5.20473 6.98381 4.44215 7.54624 3.87972C8.10866 3.31729 8.87124 3.00096 9.66664 3.00012H39.6666C40.462 3.00096 41.2246 3.31729 41.787 3.87972C42.3495 4.44215 42.6658 5.20473 42.6666 6.00012V25.5001C42.6698 28.4917 41.8583 31.4276 40.3192 33.9929C38.7801 36.5581 36.5714 38.6558 33.9303 40.0608L24.6666 45.0001ZM9.66664 6.00012V25.5001C9.66404 27.9478 10.3281 30.35 11.5875 32.4489C12.8468 34.5478 14.654 36.2641 16.815 37.4136L24.6666 41.6001L32.5182 37.4136C34.6792 36.2641 36.4864 34.5478 37.7458 32.4489C39.0052 30.35 39.6692 27.9478 39.6666 25.5001V6.00012H9.66664Z"
      fill="currentColor"
    />
  </svg>,
  'Security',
)
